import test1 from "../../../assets/test1 (1).png"
import test2 from "../../../assets/test1 (2).png"
import test3 from "../../../assets/test1 (3).png"
import test4 from "../../../assets/kyle.webp"
import comment1 from "../../../assets/comment1.png"
import comment2 from "../../../assets/comment2.png"
import comment3 from "../../../assets/comment3.png"
import comment4 from "../../../assets/comment4.png"
import comment5 from "../../../assets/comment5.png"
import comment6 from "../../../assets/comment6.png"
import comment7 from "../../../assets/comment7.png"
import comment8 from "../../../assets/comment8.png"
import comment9 from "../../../assets/comment9.png"
import comment10 from "../../../assets/comment10.png"
import comment11 from "../../../assets/comment11.png"
import comment12 from "../../../assets/comment12.png"
import comment13 from "../../../assets/comment13.png"
import comment14 from "../../../assets/comment14.png"
import comment15 from "../../../assets/comment15.png"
import comment16 from "../../../assets/comment16.png"
import comment17 from "../../../assets/comment17.png"
import comment18 from "../../../assets/comment18.png"
import comment19 from "../../../assets/comment19.png"
import comment20 from "../../../assets/comment20.png"


export const testimonials = [
    {
        name: "Kyle S.",
        quote: "This has given me my life back...",
        content:
            "I’ve tried countless sinus sprays and treatments, but nothing works like Respoclear. It provides fast and lasting relief without the harsh side effects of other products. Plus, I love that it supports my lung health and promotes healthy mucus function. I can finally breathe without feeling stuffed up all day. Highly recommended for anyone with sinus issues!",
        rating: 5,
        imageUrl: test1,
    },
    {
        name: "Sarah C.",
        quote: "I feel more energized and my breathing is clear!",
        content:
            "I’ve struggled with sinus pressure for years, especially during allergy season. After trying Respoclear,I felt an instant difference. It quickly cleared up my congestion, supported my lung health, and allowed me to breathe freely again. It's now my go-to solution for sinus discomfort!",
        rating: 5,
        imageUrl: test2,
    },
    {
        name: "Mary B.",
        quote: "The feeling I get when it enters into my body it's better than coffee...",
        content:
            "I love that Respoclear is made with natural ingredients. It's so much safer and more effective than other over-the-counter sinus products I've tried. Not only does it clear my sinuses in just a few minutes, but it also supports healthy mucus function and overall lung health. It's a must-have in my medicine cabinet!",
        rating: 5,
        imageUrl: test3,
    },
    {
        name: "Smith W.",
        quote: "Finally, I can take deep breaths without that heavy feeling in my chest!",
        content:
            "I was skeptical at first, but Breathe has truly exceeded my expectations. After just a few days, I noticed a huge improvement in how I felt. The heaviness in my chest has reduced, and I can take deeper breaths. It's a game-changer for someone like me who struggles with seasonal breathing issues.",
        rating: 5,
        imageUrl: test4,
    },
]


export const comments = [
    {
        name: "Emily",
        content: "I can finally take a deep breath without struggling. This product has truly changed my life!",
        avatar: comment1
    },
    {
        name: "Josh",
        content: "My breathing has improved so much since I started using this. I feel like I have my energy back!",
        avatar: comment2
    },
    {
        name: "Ana",
        content: "I didn't realize how much mucus buildup was affecting me until I tried this. Absolutely worth it!",
        avatar: comment3
    },
    {
        name: "Matthew",
        content: "Within a week, I noticed a huge difference in my breathing. I feel so much lighter and healthier.",
        avatar: comment4
    },
    {
        name: "Eva",
        content: "I've had chronic breathing issues for years, and this is the first thing that actually worked. Amazing!",
        avatar: comment5
    },
    {
        name: "Leo",
        content: "The relief I feel after using this is unbelievable. I can't thank you enough!",
        avatar: comment6
    },
    {
        name: "Grace",
        content: "This product really does what it says. I no longer feel like I'm fighting to catch my breath all day.",
        avatar: comment7
    },
    {
        name: "James",
        content: "As someone with seasonal allergies, this has been a lifesaver. Highly recommend!",
        avatar: comment8
    },
    {
        name: "Samantha",
        content: "I've tried so many products, but nothing compares to this. My lungs feel clear, and I can sleep better.",
        avatar: comment9
    },
    {
        name: "Oliver",
        content: "I'm finally able to go for walks without feeling out of breath. This product is incredible!",
        avatar: comment10
    },
    {
        name: "Megan",
        content: "The natural ingredients really made a difference. I feel so much better and more energized!",
        avatar: comment11
    },
    {
        name: "Noah",
        content: "It's been a game-changer for my asthma. I've already recommended it to all my friends.",
        avatar: comment12
    },
    {
        name: "Isabella",
        content: "I didn't think it would work this well, but I was wrong. My breathing has never been this clear.",
        avatar: comment13
    },
    {
        name: "Ryan",
        content:
            "Finally, something that actually helps with mucus buildup. It's been a lifesaver during the colder months.",
        avatar: comment14
    },
    {
        name: "Jessica",
        content: "I can breathe freely again! I feel like I've gained so much quality of life back.",
        avatar: comment15
    },
    {
        name: "Alex",
        content: "It works like magic! My chest feels lighter, and I can focus on my day without distractions.",
        avatar: comment16
    },
    {
        name: "Ella",
        content: "The best decision I ever made was trying this. I feel so much healthier overall!",
        avatar: comment17
    },
    {
        name: "Tyler",
        content: "Never thought I'd find something that helps this much. Breathing has become effortless!",
        avatar: comment18
    },
    {
        name: "Olivia",
        content: "This product has changed the way I live my life. I feel like a new person!",
        avatar: comment19
    },
    {
        name: "David",
        content:
            "If you're hesitant to try it, don't be. This has been the most effective solution for my breathing issues!",
        avatar: comment20
    },
]
